import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  {
    path: '/login',
    component: () => import('@/pages/login/login'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_NO);
    }
  },
  {
    path: '/login/register',
    component: () => import('@/pages/login/register'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, to.query.mode === '3' ? Constants.LOGIN_TYPE_LOGIN : Constants.LOGIN_TYPE_NO);
    }
  }
];
